import axios from 'axios';
const baseUrl = process.env.VUE_APP_API_PRINCE_URL;
const token = process.env.VUE_APP_API_PRINCE_TOKEN;

const axiosConfig = {
  baseURL: baseUrl,
  headers: {
    Authorization: `Bearer ${token}`,
    sync: true,
  },
};

const client = axios.create(axiosConfig);

export default {
  async listPrices() {
    try {
      const response = await client.get(`/api/v1/prices/versions`);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async canCreateNewVersion() {
    try {
      const response = await client.get(`/api/v1/prices/versions/can-create`);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getCurrentActiveVersion() {
    try {
      const response = await client.get(`/api/v1/prices/versions/active`);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async inactiveVersion(id, payload) {
    try {
      const response = await client.patch(
        `/api/v1/prices/versions/${id}`,
        payload,
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async getInstallments(payload) {
    try {
      const response = await client.post(
        `/api/v2/prices/installments`,
        payload,
      );

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async uploadPrices(payload) {
    try {
      const form = new FormData();

      for (const key of Object.keys(payload)) {
        form.append(key, payload[key]);
      }

      const response = await client.post(`/api/v1/prices/upload`, form, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};
